// Status
export const ACCEPTED = 'accepted';
export const ARCHIVED = 'archived';
export const REJECTED = 'rejected';
export const PENDING = 'pending';
export const ON_PAUSE = 'on_pause';
export const INACTIVE = 'inactive';
export const TERMINATED = 'terminated';
export const REJECTED_CAN_REAPPLY = 'rejected_can_reapply';

// Types of forms
export const CONNECT = 'connect';
export const END_RELATIONSHIP = 'end relationship';
export const REJECTION = 'rejection';
